<template>
  <div class="pb-8 mb-8 bg-echoes-background-black border-b border-echoes-border-light">
    <div class="flex items-center justify-between">
      <div class="flex-auto">
        <h1 class="text-2xl font-semibold text-white">
          <slot name="title"></slot>
        </h1>
        <p class="text-sm text-white/80">
          <slot name="description"></slot>
        </p>
      </div>
      <div class="flex-none">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>